import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { NgSelectConfig } from '@ng-select/ng-select';
import { filter, map } from 'rxjs';
import { projectName } from './app-const';
import { LanguageService } from './core/services/language.service';
import { SpinnerComponent } from './shared/components/spinner/spinner.component';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  imports: [RouterOutlet, SpinnerComponent]
})
export class AppComponent implements OnInit {
  title = {
    en: 'Vult Platform Management Center',
    ar: 'مركز إدارة منصة فولت'
  };

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private langService: LanguageService,
    ngSelectConfigs: NgSelectConfig
  ) {
    ngSelectConfigs.clearAllText = 'حذف الكل';
    ngSelectConfigs.loadingText = 'جارٍ التحميل';
    ngSelectConfigs.notFoundText = 'لا يوجد بيانات';
    ngSelectConfigs.placeholder = 'اختر';
    ngSelectConfigs.typeToSearchText = 'ابحث';
  }

  ngOnInit(): void {
    this.setTitle();
  }

  setTitle(): void {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let child = this.activatedRoute.firstChild;
          while (child?.firstChild) {
            child = child.firstChild;
          }
          if (child?.snapshot?.data?.['title']) {
            return child.snapshot.data['title'];
          }
          return null;
        })
      )
      .subscribe((ttl: any) => {
        const lang = localStorage.getItem('lang') || 'ar';
        if (ttl) {
          const titleStr = typeof ttl === 'object' ? (ttl[lang] || ttl.en || ttl.ar) : ttl;
          this.titleService.setTitle(`${this.title[lang === 'en' ? 'en' : 'ar']} - ${titleStr}`);
        } else {
          this.titleService.setTitle(this.title[lang === 'en' ? 'en' : 'ar']);
        }
      });
  }
}
